import { isDevelopmentMode } from '@/constants/global';

export const isDevEnvironment = process.env.NODE_ENV === 'development' || isDevelopmentMode;
